import React, { useContext } from "react";
import MyContext from "../context/MyContext";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { addDelAddress } from "../helpers/apiCalls";

const AddDeliveryAddress = () => {
  const history = useHistory();

  const { register, handleSubmit, reset } = useForm();
  const { user, setUser } = useContext(MyContext);
  const onSubmit = async (data) => {
    const res = await addDelAddress(user._id, data);
    setUser(res);
    history.push("/cart");
  };

  const clear = () => {
    reset({});
  };
  
  return (
    <div className="user-dashboard">
      <div className="bill-address-form">
        <form onSubmit={handleSubmit(onSubmit)}>
          <h2>Add Delivery address</h2>
          <div className="bill-address">
            <input
              placeholder="Full Name"
              {...register("fullName", {
                required: true,
              })}
            />
            <input
              placeholder="Street"
              {...register("street", {
                required: true,
              })}
            />
            <input
              placeholder="House Number"
              {...register("houseNo", {
                required: true,
              })}
            />
            <input
              placeholder="PostCode"
              {...register("postCode", {
                required: true,
              })}
            />
            <input
              placeholder="City"
              {...register("city", {
                required: true,
              })}
            />
            <input
              placeholder="Country"
              {...register("country", {
                required: true,
              })}
            />
            <div className="submit">
              <button className="button-bg" type="submit">
                Save
              </button>
              <button className="button-bg-red" type="button" onClick={clear}>
                Clear
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddDeliveryAddress;
